export function hidePageLoader() {
  const loader = document.getElementById('page-loader');
  if (!loader || loader.classList.contains('hidden')) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) {
    loader.classList.add('hidden');
    return;
  }

  loader.classList.add('hiding');
  loader.addEventListener('transitionend', () => loader.classList.add('hidden'), { once: true });
}
